import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import './Font/font.css';
import DSRequestFormService from '../../services/DSRequestForm.service';
import { useLocation } from 'react-router-dom';

export default function ThankYouPage() {
    const location = useLocation();
    const { domainId } = location?.state;
    const [customForm, setCustomForm] = useState();
    const [fontStyle, setFontStyle] = useState();
    const getCustomForm = async () => {
        try {
            const { data } = await DSRequestFormService.getPublicCustomize(
                domainId
            );
            const item = data?.resultData;
            document.body.style.backgroundColor =
                item?.customizeStyle?.mainColor;
            setCustomForm(item?.thankyou);
            setFontStyle(item?.fontStyle);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        getCustomForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="w-full h-full bg-white">
            <div className="grid items-center justify-center pt-60">
                <div className="justify-center my-auto space-y-3">
                    <div className="mx-auto text-center">
                        <Icon />
                    </div>
                    <div className="text-[#7B67FB] font-medium text-3xl text-center">
                        {customForm?.topic || ''}
                    </div>
                    <div className="text-center whitespace-pre-line">
                        <div
                            className={fontStyle?.fontFamily}
                            style={{
                                fontSize: fontStyle?.fontSize,
                            }}
                        >
                            {customForm?.detail || ''}
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const Icon = () => {
    return (
        <svg
            width="317"
            height="172"
            viewBox="0 0 317 172"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_7680_391299)">
                <path
                    d="M247.192 66.6891C247.127 66.6892 247.064 66.6694 247.011 66.6324L159.405 5.62121C159.139 5.4364 158.822 5.33764 158.498 5.33819C158.173 5.33875 157.857 5.43859 157.591 5.6243L70.616 66.6318C70.5472 66.68 70.462 66.699 70.3793 66.6844C70.2965 66.6699 70.2229 66.6231 70.1746 66.5543C70.1264 66.4855 70.1074 66.4004 70.122 66.3176C70.1365 66.2348 70.1833 66.1612 70.2521 66.113L157.227 5.10553C157.599 4.84557 158.042 4.70583 158.496 4.70508C158.951 4.70433 159.394 4.84262 159.767 5.10135L247.373 66.1124C247.428 66.1509 247.47 66.2061 247.492 66.27C247.514 66.3338 247.514 66.403 247.494 66.4673C247.474 66.5317 247.434 66.5879 247.379 66.6278C247.325 66.6677 247.259 66.6892 247.192 66.6891L247.192 66.6891Z"
                    fill="#3F3D56"
                />
                <path
                    d="M75.5898 68.8494L158.588 7.33789L242.215 73.2262L162.864 120.267L119.783 110.447L75.5898 68.8494Z"
                    fill="#E6E6E6"
                />
                <path
                    d="M123.421 149.323H82.4181C82.1663 149.324 81.917 149.274 81.6843 149.178C81.4516 149.082 81.2401 148.941 81.0619 148.763C80.8838 148.585 80.7425 148.374 80.6461 148.141C80.5496 147.909 80.5 147.66 80.5 147.408C80.5 147.156 80.5496 146.907 80.6461 146.674C80.7425 146.442 80.8838 146.23 81.0619 146.052C81.2401 145.874 81.4516 145.733 81.6843 145.637C81.917 145.541 82.1663 145.492 82.4181 145.492H123.421C123.673 145.492 123.922 145.541 124.155 145.637C124.388 145.733 124.599 145.874 124.777 146.052C124.955 146.23 125.097 146.442 125.193 146.674C125.289 146.907 125.339 147.156 125.339 147.408C125.339 147.66 125.289 147.909 125.193 148.141C125.097 148.374 124.955 148.585 124.777 148.763C124.599 148.941 124.388 149.082 124.155 149.178C123.922 149.274 123.673 149.324 123.421 149.323Z"
                    fill="#7B67FB"
                />
                <path
                    d="M97.129 141.087H82.4181C82.1663 141.087 81.917 141.038 81.6843 140.942C81.4516 140.846 81.2401 140.705 81.0619 140.527C80.8838 140.349 80.7425 140.138 80.6461 139.905C80.5496 139.673 80.5 139.423 80.5 139.171C80.5 138.92 80.5496 138.67 80.6461 138.438C80.7425 138.205 80.8838 137.994 81.0619 137.816C81.2401 137.638 81.4516 137.497 81.6843 137.401C81.917 137.305 82.1663 137.256 82.4181 137.256H97.129C97.3808 137.256 97.6302 137.305 97.8629 137.401C98.0956 137.497 98.307 137.638 98.4852 137.816C98.6633 137.994 98.8046 138.205 98.9011 138.438C98.9975 138.67 99.0471 138.92 99.0471 139.171C99.0471 139.423 98.9975 139.673 98.9011 139.905C98.8046 140.138 98.6633 140.349 98.4852 140.527C98.307 140.705 98.0956 140.846 97.8629 140.942C97.6302 141.038 97.3808 141.087 97.129 141.087Z"
                    fill="#7B67FB"
                />
                <path
                    d="M159.754 103.111C159.443 103.111 159.134 103.05 158.845 102.933L107.658 81.6935V15.2115C107.659 14.6237 107.893 14.0601 108.308 13.6444C108.724 13.2287 109.288 12.9948 109.876 12.9941H208.075C208.662 12.9948 209.226 13.2287 209.642 13.6444C210.057 14.0601 210.291 14.6237 210.292 15.2115V81.7399L210.196 81.781L160.691 102.922C160.394 103.047 160.076 103.111 159.754 103.111Z"
                    fill="white"
                />
                <path
                    d="M159.754 103.271C159.422 103.271 159.093 103.207 158.785 103.081L107.5 81.8014V15.2137C107.501 14.5838 107.751 13.9799 108.197 13.5345C108.642 13.0891 109.246 12.8386 109.876 12.8379H208.075C208.705 12.8386 209.308 13.0891 209.754 13.5345C210.199 13.9799 210.45 14.5838 210.45 15.2137V81.8466L160.753 103.07C160.437 103.203 160.097 103.271 159.754 103.271ZM108.134 81.3783L159.027 102.496C159.502 102.688 160.033 102.685 160.506 102.487L209.817 81.4284V15.2137C209.816 14.7518 209.633 14.3089 209.306 13.9823C208.979 13.6557 208.537 13.472 208.075 13.4714H109.876C109.414 13.472 108.971 13.6557 108.644 13.9823C108.318 14.3089 108.134 14.7518 108.134 15.2137L108.134 81.3783Z"
                    fill="#3F3D56"
                />
                <path
                    d="M246.563 66.0547H246.499L210.134 81.5828L160.379 102.829C160.184 102.91 159.976 102.953 159.765 102.954C159.554 102.955 159.345 102.915 159.15 102.835L107.817 81.5384L70.5584 66.08L70.5015 66.0547H70.4381C69.8502 66.0553 69.2866 66.2892 68.8709 66.7049C68.4552 67.1206 68.2214 67.6842 68.2207 68.2721V164.57C68.2214 165.158 68.4552 165.722 68.8709 166.138C69.2866 166.553 69.8502 166.787 70.4381 166.788H246.563C247.151 166.787 247.714 166.553 248.13 166.138C248.546 165.722 248.779 165.158 248.78 164.57V68.2721C248.779 67.6842 248.546 67.1206 248.13 66.7049C247.714 66.2892 247.151 66.0553 246.563 66.0547ZM248.147 164.57C248.146 164.99 247.979 165.393 247.682 165.69C247.385 165.987 246.983 166.154 246.563 166.154H70.4381C70.0181 166.154 69.6153 165.987 69.3183 165.69C69.0213 165.393 68.8544 164.99 68.8542 164.57V68.2721C68.8548 67.8625 69.0137 67.469 69.2977 67.1738C69.5816 66.8786 69.9687 66.7047 70.3779 66.6882L107.817 82.2227L158.906 103.421C159.459 103.646 160.079 103.643 160.629 103.411L210.134 82.2702L246.626 66.6882C247.035 66.7059 247.421 66.8803 247.704 67.1753C247.987 67.4703 248.146 67.8632 248.147 68.2721V164.57Z"
                    fill="#3F3D56"
                />
                <path
                    d="M159.242 84.2624C157.352 84.266 155.512 83.6549 154 82.5214L153.907 82.4511L134.168 67.3387C133.254 66.6383 132.487 65.7647 131.91 64.7678C131.334 63.7709 130.959 62.6702 130.808 61.5286C130.657 60.3869 130.732 59.2267 131.03 58.1141C131.327 57.0016 131.84 55.9584 132.541 55.0443C133.241 54.1302 134.115 53.363 135.112 52.7865C136.109 52.21 137.209 51.8355 138.351 51.6843C139.493 51.5332 140.653 51.6084 141.765 51.9057C142.878 52.203 143.921 52.7165 144.835 53.4169L157.62 63.2202L187.833 23.8181C188.534 22.9042 189.408 22.1373 190.405 21.5612C191.402 20.985 192.503 20.6109 193.644 20.4602C194.786 20.3095 195.946 20.3851 197.059 20.6828C198.171 20.9805 199.214 21.4944 200.128 22.1952L199.94 22.4502L200.133 22.1989C201.976 23.6156 203.182 25.7058 203.487 28.0108C203.791 30.3157 203.169 32.6473 201.756 34.4938L166.218 80.8401C165.396 81.9081 164.339 82.7724 163.129 83.3659C161.92 83.9594 160.589 84.2662 159.242 84.2624Z"
                    fill="#4ACE8F"
                />
            </g>
            <defs>
                <clipPath id="clip0_7680_391299">
                    <rect
                        width="180.559"
                        height="162.084"
                        fill="white"
                        transform="translate(68.2207 4.70508)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
